import React, {Fragment} from 'react';
import './App.css';
import UserSessionService, {isAuthenticated} from "./services/UserSessionService";
import AuthenticatedRouter from "./components/AuthenticatedRouter";
import UnauthenticatedRouter from "./components/UnauthenticatedRouter";
import {ToastContainer} from "react-toastify";
import {ResponsiveHelper} from "./utils/ResponsiveHelper";

class App extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: isAuthenticated()
        };

        this.handleResize = this.handleResize.bind(this);
    }

    isMobile() {
        return window.innerWidth < 575;
    }

    handleResize(){
        let newState = {isMobile: this.isMobile};
        if(window) {
            let size = ResponsiveHelper.calculateSize(window.innerWidth);
            if(size!==this.state.responsiveSize) {
                window.responsiveSize = size;
                newState.responsiveSize = size;
            }
        }
        this.setState(newState);
    }

    componentDidMount() {
        this.handleResize();
        if (window) window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        if (window) window.removeEventListener('resize', this.handleResize);
    }

    userHasAuthenticated() {
        this.setState({isAuthenticated: isAuthenticated()});
    }

    logout() {
        UserSessionService.logout(
            () => this.setState({isAuthenticated: false})
        );
    }

    render() {

        if (this.state.isAuthenticated) {
            let childProps = {
                isMobile: this.isMobile(),
                logout: this.logout.bind(this),
                isAuthenticated: this.state.isAuthenticated,
                onUserAuthenticated: this.userHasAuthenticated.bind(this),
            };

            return <Fragment>
                <ToastContainer position="top-right" autoClose={5000} style={{
                    align: "right",
                    zIndex: 1999,
                    width: "100%",
                }}/>
            <AuthenticatedRouter childProps={childProps}/>
            </Fragment>
        } else {
            let childProps = {
                isMobile: this.isMobile(),
                isAuthenticated: this.state.isAuthenticated,
                onUserAuthenticated: this.userHasAuthenticated.bind(this)
            };
            return <UnauthenticatedRouter childProps={childProps}/>
        }

    }

}

export default App;
